import { render, staticRenderFns } from "./productDuction.vue?vue&type=template&id=c3e822e0&scoped=true&"
import script from "./productDuction.vue?vue&type=script&lang=js&"
export * from "./productDuction.vue?vue&type=script&lang=js&"
import style0 from "./productDuction.vue?vue&type=style&index=0&id=c3e822e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e822e0",
  null
  
)

component.options.__file = "productDuction.vue"
export default component.exports